import i18n from '@/i18n';

function initFormClient() {
    return {
        corp_number: '',
        name: '',
        kana_name: '',
        phone_number: '',
        profile: '',
        address_1: '',
        address_2: '',
        url: '',
        postal_code: '',
        province: '',
        type_id: null,
        option_type: []
    };
}

function configError() {
    return {
        name: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.name'),
            errorCustomMess: '',
            typesValidate: ['required', 'max255']
        },
        phone_number: {
            isNumber: false,
            isConvertHalfsize: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.phone_number'),
            errorCustomMess: '',
            typesValidate: ['max20', 'number-hyphens']
        },
        kana_name: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.kana_name'),
            errorCustomMess: '',
            typesValidate: ['required', 'katakana']
        },
        postal_code: {
            isNumber: true,
            maxlength: 10,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.postal_code'),
            errorCustomMess: '',
            typesValidate: ['required']
        },
        province: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.province'),
            errorCustomMess: '',
            typesValidate: ['required', 'max255']
        },
        address_1: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.address_1'),
            errorCustomMess: '',
            typesValidate: ['required', 'max255'],
            placeholder: '市区町村'
        },
        address_2: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.address_2'),
            errorCustomMess: '',
            typesValidate: ['max255'],
            placeholder: '番地・その他'
        },
        url: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('client.url'),
            errorCustomMess: '',
            typesValidate: ['max255', 'url']
        },
        corp_number: {
            isNumber: true,
            length: 13,
            errorField: i18n.t('client.corp_number'),
            typesValidate: ['maxCustom'],
            error: false
        },
        type_id: {
            trackBy: 'id',
            label: 'name',
            errorField: '種別',
            valueSync: null,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: [],
            openDirection: 'top'
        }
    };
}

function initFormClientSupport() {
    return {
        name: 'ご担当者',
        kana_name: '',
        phone_number: '',
        email: '',
        department: '',
        mobile_number: ''
    };
}

function configSupportError() {
    return {
        name: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            placeholder: 'ご担当者',
            errorField: i18n.t('clientSupport.name'),
            errorCustomMess: '',
            typesValidate: ['required', 'max255']
        },
        department: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('clientSupport.department'),
            errorCustomMess: '',
            typesValidate: ['max255']
        },
        phone_number: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('clientSupport.phone_number'),
            errorCustomMess: '',
            isConvertHalfsize: true,
            typesValidate: ['max20', 'number-hyphens']
        },
        kana_name: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('clientSupport.kana_name'),
            errorCustomMess: '',
            typesValidate: ['katakana']
        },
        mobile_number: {
            isNumber: false,
            isConvertHalfsize: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('clientSupport.mobile_number'),
            errorCustomMess: '',
            typesValidate: ['max20']
        },
        email: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('clientSupport.email'),
            errorCustomMess: '',
            typesValidate: ['email', 'max255']
        }
    };
}

export { initFormClient, initFormClientSupport, configError, configSupportError };
